var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 513,
    viewBox: "0 0 513 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_1495)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 495,
    height: 495,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.484,
    y: 9,
    width: 17.2421,
    height: 168,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.727,
    y: 9,
    width: 17.2421,
    height: 168,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 9,
    width: 17.2421,
    height: 168,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.242,
    y: 9,
    width: 17.2421,
    height: 168,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 153L16 8.25002L143.739 8.25003L16 153Z",
    fill: "#0098FD"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 377,
    transform: "matrix(-1 0 0 1 34 57)",
    fill: "#0098FD"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 495,
    height: 495,
    rx: 32,
    stroke: "#5D647B",
    strokeWidth: 17
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_1495"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 495,
    height: 495,
    rx: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnLight);
export default __webpack_public_path__ + "static/media/onLight.6f968818a46808dad356fa5762152001.svg";
export { ForwardRef as ReactComponent };